{
  "dashboard": {
    "title": "Dashboard",
    "description": "Welcome to your dashboard",
    "patients": "Patients",
    "evaluations": "Evaluations",
    "patientsDescription": "Manage your patients",
    "evaluationsDescription": "Manage your evaluations",
    "trialCallout": {
      "title": "Add your first practitioner to start your {{days}}-day free trial",
      "description": "Each practitioner gets their own account to run evaluations from the MetaDevProfile mobile app. Adding your first practitioner automatically activates your free trial.",
      "cta": "Add my first practitioner"
    },
    "stats": {
      "subscription": {
        "title": "Subscription",
        "seats": "Seats",
        "monthlyCost": "Monthly cost",
        "status": {
          "active": "Active",
          "trialing": "Trial",
          "paused": "Paused",
          "past_due": "Past due",
          "canceled": "Canceled",
          "unpaid": "Unpaid",
          "none": "No subscription",
          "incomplete": "Incomplete"
        }
      },
      "users": {
        "title": "Practitioners",
        "total": "Total",
        "active": "Active",
        "seeMore": "See more",
        "recentUsers": "Recent practitioners"
      },
      "deviceRequests": {
        "title": "Device Requests",
        "pending": "Pending",
        "seeMore": "See more",
        "recentRequests": "Recent requests",
        "cardTitle": "Device Approval Requests",
        "cardDescription": "Manage device authorization requests from your team members",
        "cardDescriptionPopulated": "Review and approve device authorization requests from your team members",
        "noPending": "No pending device requests",
        "unknownDevice": "Unknown device",
        "unknownType": "Unknown type",
        "at": "at",
        "approve": "Approve",
        "deny": "Deny"
      }
    }
  },
  "navigation": {
    "general": "General",
    "dashboard": "Dashboard",
    "users": "Users",
    "groups": "Groups",
    "billing": "Billing",
    "roles": {
      "institution": "Institution",
      "practitioner": "Practitioner"
    },
    "emailVerification": {
      "title": "Verify your Email",
      "description": "Verify your email and click on the verification link to finalize your account.",
      "resendButton": "Resend",
      "resendSuccess": "Verification email sent! Please check your inbox."
    }
  },
  "users": {
    "title": "Users",
    "description": "Manage practitioners in your institution",
    "inviteUser": "Invite a practitioner",
    "searchPlaceholder": "Search by name or email...",
    "noUsers": "No users found",
    "table": {
      "name": "Name",
      "email": "Email",
      "phone": "Phone",
      "status": "Status",
      "inviteDate": "Invite Date",
      "actions": "Actions"
    },
    "status": {
      "pending": "Pending",
      "accepted": "Accepted",
      "declined": "Declined"
    },
    "actions": {
      "resendInvite": "Resend invitation",
      "revokeAccess": "Revoke access",
      "viewDetails": "View details",
      "resetPassword": "Reset password",
      "edit": "Edit practitioner",
      "delete": "Delete practitioner"
    },
    "invite": {
      "title": "Invite a practitioner",
      "email": "Email address",
      "emailPlaceholder": "practitioner@example.com",
      "send": "Send invitation",
      "cancel": "Cancel",
      "success": "Invitation sent successfully",
      "error": "Error sending invitation"
    },
    "filters": {
      "all": "All",
      "pending": "Pending",
      "accepted": "Accepted",
      "declined": "Declined"
    },
    "details": {
      "title": "User Details",
      "description": "Complete information about this institution member",
      "personalInfo": "Personal Information",
      "name": "Full name",
      "email": "Email",
      "phone": "Phone",
      "gender": "Gender",
      "genderMan": "Man",
      "genderWoman": "Woman",
      "genderOther": "Other",
      "institutionInfo": "Institution Information",
      "inviteStatus": "Invitation status",
      "inviteDate": "Invitation date",
      "devices": {
        "title": "Authorized devices ({{count}})",
        "status": {
          "approved": "Approved",
          "pending": "Pending",
          "rejected": "Rejected",
          "revoked": "Revoked"
        },
        "defaultName": "Device {{type}}",
        "type": "Type: {{type}}",
        "createdAt": "Created: {{date}}",
        "lastUsed": "Last used: {{date}}",
        "revokeAccess": "Revoke access",
        "revoking": "Revoking...",
        "noDevices": "No authorized devices",
        "revokeDialog": {
          "title": "Revoke device access",
          "description": "Are you sure you want to revoke access for the device",
          "warning": "The user will need to request a new authorization to use this device."
        }
      }
    },
    "create": {
      "button": "Create Account",
      "trialCapReached": "Trial seat limit reached ({{count}}). Contact us to increase it.",
      "title": "Create User Account",
      "description": "Create an account directly for a practitioner in your institution",
      "firstName": "First Name",
      "firstNamePlaceholder": "Enter first name",
      "lastName": "Last Name",
      "lastNamePlaceholder": "Enter last name",
      "email": "Email Address",
      "emailPlaceholder": "practitioner@example.com",
      "phone": "Phone",
      "phonePlaceholder": "Optional",
      "password": "Password",
      "passwordPlaceholder": "Minimum 6 characters",
      "confirm": "Create Account",
      "cancel": "Cancel",
      "success": "Account created successfully",
      "error": "Error creating account"
    },
    "addSeat": {
      "title": "Add a Seat",
      "description": "Adding a new user will add a seat to your subscription. Please review the cost changes below.",
      "currentSeats": "Current seats",
      "newSeats": "New seats",
      "currentMonthlyCost": "Current monthly cost",
      "additionalCost": "Additional cost",
      "newMonthlyCost": "New monthly cost",
      "confirm": "Confirm & Create",
      "cancel": "Cancel",
      "previewError": "Unable to load cost preview. Please try again.",
      "trial": {
        "title": "{{count}}-day free trial",
        "description": "No payment is required today. The monthly billing shown below will only start once your trial period ends.",
        "afterTrialLabel": "Monthly cost after trial"
      },
      "trialOngoing": {
        "title": "Seat included in your ongoing trial",
        "description": "No payment is required. The monthly billing shown below will only start once your trial period ends."
      },
      "success": {
        "trial": "User created! Your free trial has started.",
        "noPayment": "User created!"
      },
      "payment": {
        "description": "Enter your payment details to complete the subscription.",
        "pay": "Pay now",
        "success": "Payment successful! User created.",
        "finalizing": "Finalizing...",
        "genericError": "An error occurred during payment. Please try again."
      }
    },
    "revokeDialog": {
      "title": "Revoke Access",
      "description": "Are you sure you want to revoke {{name}}'s access? This action will remove the user from your institution.",
      "confirm": "Revoke Access",
      "cancel": "Cancel",
      "revoking": "Revoking..."
    },
    "edit": {
      "title": "Edit Practitioner",
      "description": "Update this practitioner's information",
      "firstName": "First Name",
      "firstNamePlaceholder": "Enter first name",
      "lastName": "Last Name",
      "lastNamePlaceholder": "Enter last name",
      "email": "Email Address",
      "emailPlaceholder": "practitioner@example.com",
      "phone": "Phone",
      "phonePlaceholder": "Optional",
      "confirm": "Save Changes",
      "cancel": "Cancel",
      "success": "Practitioner updated successfully",
      "error": "Error updating practitioner"
    },
    "delete": {
      "title": "Delete Practitioner",
      "description": "Are you sure you want to delete {{name}} from your institution?",
      "warning": "The seat will be removed from your subscription. If this practitioner has no patients or evaluations on record, their account will be permanently deleted and their email address will become available for a new account.",
      "confirm": "Delete",
      "cancel": "Cancel",
      "success": "Practitioner deleted successfully",
      "error": "Error deleting practitioner"
    },
    "resetPassword": {
      "title": "Reset Password",
      "description": "Reset the password for {{name}}. They will be notified of the new password and should change it after their next login.",
      "newPassword": "New Password",
      "newPasswordPlaceholder": "Enter new password",
      "confirmPassword": "Confirm Password",
      "confirmPasswordPlaceholder": "Confirm new password",
      "generatePassword": "Generate secure password",
      "showPassword": "Show password",
      "hidePassword": "Hide password",
      "passwordMismatch": "Passwords don't match",
      "passwordTooShort": "Password must be at least 6 characters",
      "warning": {
        "shareSecurely": "Make sure to share the new password securely"
      },
      "confirm": "Reset Password",
      "cancel": "Cancel",
      "success": "Password reset successfully",
      "error": "Failed to reset password"
    }
  },
  "groups": {
    "title": "Groups",
    "description": "Manage groups and assign members for patient sharing",
    "createButton": "Create Group",
    "noGroups": "No groups found",
    "memberCount": "{{count}} member(s)",
    "create": {
      "title": "Create Group",
      "description": "Create a new group to organize your institution members",
      "name": "Group Name",
      "namePlaceholder": "Enter group name",
      "descriptionLabel": "Description",
      "descriptionPlaceholder": "Enter a description (optional)",
      "confirm": "Create Group",
      "cancel": "Cancel"
    },
    "edit": {
      "title": "Edit Group",
      "description": "Update the group information",
      "confirm": "Save Changes",
      "cancel": "Cancel"
    },
    "delete": {
      "title": "Delete Group",
      "description": "Are you sure you want to delete the group \"{{name}}\"? This action cannot be undone.",
      "confirm": "Delete",
      "cancel": "Cancel"
    },
    "members": {
      "title": "Manage Members",
      "description": "Manage members of the group \"{{name}}\"",
      "addMember": "Add a Member",
      "selectMember": "Select a member",
      "selectPlaceholder": "Choose a member...",
      "noAvailableMembers": "All institution members are already in this group",
      "currentMembers": "Members ({{count}})",
      "noMembers": "No members in this group yet"
    }
  },
  "notifications": {
    "title": "Notifications",
    "description": "Stay informed about your institution's activities",
    "unreadCount_one": "1 unread",
    "unreadCount_other": "{{count}} unread",
    "markAllRead": "Mark all as read",
    "time": {
      "justNow": "Just now",
      "hoursAgo_one": "1 hour ago",
      "hoursAgo_other": "{{count}} hours ago",
      "yesterday": "Yesterday"
    },
    "empty": {
      "title": "No notifications",
      "description": "You don't have any notifications yet. They will appear here when your institution has activities."
    },
    "error": {
      "loadFailed": "Failed to load notifications",
      "retry": "Retry"
    },
    "status": {
      "read": "Read"
    }
  },
  "profile": {
    "title": "Institution Profile",
    "description": "Manage your institution's information and settings",
    "tabs": {
      "personal": "Personal Information",
      "institution": "Institution Information",
      "security": "Security"
    },
    "personal": {
      "title": "Personal Information",
      "description": "Update your personal data",
      "success": "Personal information updated successfully",
      "successDescription": "The personal information has been updated successfully",
      "error": "Error updating personal information",
      "errorDescription": "An error occurred while updating the personal information.",
      "fields": {
        "firstName": "First Name",
        "lastName": "Last Name",
        "email": "Email",
        "phone": "Phone",
        "gender": "Gender",
        "genderOptions": {
          "man": "Man",
          "woman": "Woman",
          "other": "Other"
        },
        "language": "Language",
        "languageOptions": {
          "en": "English",
          "fr": "French"
        },
        "theme": "Theme",
        "themeOptions": {
          "light": "Light",
          "dark": "Dark",
          "system": "System"
        }
      },
      "saveChanges": "Save Changes",
      "updating": "Updating...",
      "personalization": {
        "title": "Personalization",
        "description": "Customize your experience"
      }
    },
    "institution": {
      "title": "Institution Information",
      "description": "View your institution's data",
      "updateNote": "To modify institution information, please send an email to support@metadevprofile.com with the new information.",
      "fields": {
        "institutionName": "Institution Name",
        "companyRegistration": "Company Registration",
        "address": "Address",
        "city": "City",
        "zipCode": "ZIP Code",
        "state": "State",
        "country": "Country"
      }
    },
    "security": {
      "title": "Security Settings",
      "description": "Manage your account security",
      "changePassword": {
        "title": "Change Password",
        "description": "Update your account password for enhanced security.",
        "fields": {
          "currentPassword": "Current Password",
          "newPassword": "New Password",
          "confirmPassword": "Confirm New Password"
        },
        "button": "Update Password",
        "updating": "Updating...",
        "success": "Password updated successfully",
        "successDescription": "The password has been updated successfully",
        "error": "Error updating password",
        "errorDescription": "An error occurred while updating the password.",
        "errors": {
          "currentRequired": "Current password is required",
          "newRequired": "New password is required",
          "confirmRequired": "Please confirm your new password",
          "minLength": "Password must be at least 6 characters",
          "noMatch": "Passwords do not match",
          "samePassword": "New password must be different from current password",
          "wrongCurrent": "Current password is incorrect"
        }
      },
      "twoFactor": {
        "title": "Two-Factor Authentication",
        "description": "Add an extra layer of security to your account.",
        "button": "Enable 2FA"
      }
    },
    "error": {
      "notFound": "Institution not found",
      "description": "Unable to load institution information"
    }
  },
  "billing": {
    "title": "Billing",
    "description": "Manage your subscription, payment method, and invoices",
    "subscription": {
      "title": "Subscription",
      "seats": "Seats",
      "monthlyCost": "Monthly cost",
      "nextBilling": "Next billing date",
      "trialingUntil": "Free trial until {{date}}",
      "paymentMethodNeededTitle": "Add a payment method",
      "paymentMethodNeededDescription": "Add a payment method before {{date}} to keep access to your account.",
      "pausedTitle": "Subscription paused",
      "pausedDescription": "Access is blocked because no payment method was added before the trial ended. Add a card then resume the subscription to restore access."
    },
    "paymentMethod": {
      "title": "Payment Method",
      "change": "Change",
      "none": "No payment method on file",
      "expires": "Expires",
      "dialogTitle": "Update Payment Method",
      "dialogDescription": "Enter your new card details below.",
      "save": "Save card",
      "updateError": "Failed to update payment method"
    },
    "invoices": {
      "title": "Invoice History",
      "none": "No invoices yet",
      "status": {
        "paid": "Paid",
        "open": "Open",
        "draft": "Draft",
        "uncollectible": "Uncollectible",
        "void": "Void"
      }
    },
    "cancel": {
      "button": "Cancel subscription",
      "title": "Cancel Subscription",
      "description": "Are you sure you want to cancel your subscription? It will remain active until the end of the current billing period.",
      "confirm": "Confirm cancellation",
      "back": "Go back"
    },
    "reactivate": {
      "button": "Reactivate subscription"
    },
    "resume": {
      "processing": "Payment accepted, activation in progress...",
      "confirming": "Payment is being confirmed, the page will update shortly",
      "button": "Resume subscription",
      "paymentMethodRequired": "Add a payment method before resuming the subscription."
    },
    "blocked": {
      "title": "Subscription Inactive",
      "description": "Your institution's subscription is inactive. Please contact your administrator to restore access."
    }
  },
  "device": {
    "title": "Device Authorization",
    "description": "Manage authorized devices for your institution: {{institution}}",
    "unknownInstitution": "Unknown Institution",
    "unknownDevice": "Unknown Device",
    "institutionMember": {
      "title": "Institution Member",
      "description": "As a member of {{institution}}, your devices require authorization for security purposes."
    },
    "authorizedDevices": {
      "title": "Authorized Devices",
      "empty": "No authorized devices found"
    },
    "authorizedOn": "Authorized on",
    "status": {
      "authorized": "Authorized",
      "pending": "Pending",
      "denied": "Denied"
    },
    "info": {
      "note": "Device authorization is managed by your institution administrator. Contact them for device approval requests."
    },
    "errors": {
      "approveDeviceFailed": "Failed to approve device",
      "denyDeviceFailed": "Failed to deny device",
      "loadAuthorizationsFailed": "Failed to load device authorizations",
      "loadPendingRequestsFailed": "Failed to load pending device requests",
      "loadUserAuthorizationsFailed": "Failed to load user device authorizations",
      "revokeDeviceFailed": "Failed to revoke device authorization"
    }
  },
  "success": {
    "institutionCreatedSuccessfully": "Institution created successfully",
    "paymentMethodUpdated": "Payment method updated successfully",
    "subscriptionResumed": "Subscription resumed successfully",
    "subscriptionCanceled": "Subscription will be canceled at the end of the current period",
    "subscriptionReactivated": "Subscription reactivated successfully",
    "institutionMemberCreatedSuccessfully": "Institution member created successfully",
    "institutionMemberUpdatedSuccessfully": "Member updated successfully",
    "memberRemovedSuccessfully": "Member removed successfully",
    "passwordResetSuccessfully": "Password reset successfully",
    "groupCreated": "Group created successfully",
    "groupUpdated": "Group updated successfully",
    "groupDeleted": "Group deleted successfully",
    "groupMemberAdded": "Member added to group",
    "groupMemberRemoved": "Member removed from group",
    "deviceAuthorizationApprovedSuccessfully": "Device authorization approved successfully",
    "deviceAuthorizationDeniedSuccessfully": "Device authorization denied successfully",
    "deviceAuthorizationRevokedSuccessfully": "Device authorization revoked successfully"
  },
  "errors": {
    "createUserFailed": "Failed to create user",
    "createInstitutionFailed": "Failed to create institution",
    "loadStatsFailed": "Failed to load statistics",
    "loadUsersFailed": "Failed to load users",
    "loadInstitutionFailed": "Failed to load institution",
    "loadInstitutionsFailed": "Failed to load institutions",
    "loadSubscriptionFailed": "Failed to load subscription information",
    "loadSeatPreviewFailed": "Failed to load seat cost preview",
    "resetPasswordFailed": "Failed to reset password",
    "updateUserFailed": "Failed to update practitioner",
    "deleteUserFailed": "Failed to delete practitioner",
    "updateInstitutionFailed": "Failed to update institution",
    "loadGroupsFailed": "Failed to load groups",
    "createGroupFailed": "Failed to create group",
    "updateGroupFailed": "Failed to update group",
    "deleteGroupFailed": "Failed to delete group",
    "addGroupMemberFailed": "Failed to add member to group",
    "removeGroupMemberFailed": "Failed to remove member from group",
    "loadPaymentMethodFailed": "Failed to load payment method",
    "createSetupIntentFailed": "Failed to initialize card update",
    "updatePaymentMethodFailed": "Failed to update payment method",
    "loadInvoicesFailed": "Failed to load invoices",
    "cancelSubscriptionFailed": "Failed to cancel subscription",
    "reactivateSubscriptionFailed": "Failed to reactivate subscription",
    "resumeSubscriptionFailed": "Failed to resume subscription",
    "resumeSubscriptionPaymentFailed": "Payment authentication failed. Please try again.",
    "stripeUnavailable": "Payment service unavailable. Please try again later.",
    "trialSeatLimitReached": "Trial seat limit reached"
  }
}
